import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      "welcome": "Welcome to Compte-Gouttes Workshop",
      "validate_decision": "Validate Decision",
      "Suivant": "Next",
      "Précédent" : "Previous",
      "Déroulement de l'atelier": "How does it work ?",
      "Commencer le jeu": "Start the simulation",
      "Commencer l'atelier": "Start the simulation",
      "Voici les voix dont disposent chaque acteur pour ce tour": "Here are voices summary",
      "Tour" : "Round",
      "Valider la décision" : "Validate decisions",
      "Tours": "Rounds",
      "Économie d'eau": "Water Saving",
      "Agriculture": "Agriculture",
      "Industrie": "Industry",
      "Public": "Public",
      "Consommateurs": "Consumers",
      "Courbe d'objectif": "Target Curve",
      "endOfLastRound": "It's the end of your last turn!",
      "congratulations": "Congratulations!",
      "achievement": "You achieved {{percentage}}% of your goal.",
      "waterSavingsRecap": "Here is the recap of the water savings you made over time:",
      "welcomeMessage": "Hello everyone, it's {{year}}, welcome to the {{congressNumber}}th Water Congress.",
      "objectivesStatus": "The 10-year objectives are {{objectives}}, this year droughts are expected to be {{droughtType}}, decisions should focus on {{measuresTerm}} measures.",
      "lowPrecipitation": "This year precipitation levels were particularly low, some rivers are almost dry, and groundwater levels are under great stress. We are facing a drought.",
      "shortTermNeeds": "You need to save {{needs}}",
      "waterDrop": "water drop",
      "nextTurn": " in the next turn.",
      "waterSavingsEvolution": "Water Savings Evolution",
      "Sélectionnée": "Selected",
      "Sélectionner": "Select",
      "Situation de crise - choisissez des mesures d'urgence": "Crisis situation - choose emergency measures",
      "otherIndicators": "Other Indicators",
      "impactOtherIndicators": "Impact on other indicators",
      "discoverTerritory": "Discover what your territory looks like!",
      "downloadPDF": "Download the PDF",
      "gameSummary": "Game Summary",
      "accessSummary": "Access the game summary",
      "reviewPastEvents": "Let's review the key events of the past year",
      "biodiversity": "Biodiversity",
      "energySobriety": "Energy Sobriety",
      "economicHealth": "Economic Health",
      "popularity": "Popularity",
      "waterQuality": "Water Quality",
      "context": {
        "title": "Context",
        "householdsWithoutWater": "households were deprived of water",
        "awarenessCampaign": "people sensitized to water"
      },
      "events": {
        "olympics": {
          "title": "Olympic Games",
          "description": "The Olympic Games took place this year.",
          "heatwaves": "heatwaves observed"
        },
        "cop30": {
          "title": "COP 30 in Brazil",
          "description": "COP 30 in Brazil",
          "hottestYear": "hottest year recorded"
        },
        "localElections": {
          "title": "Municipal Elections",
          "description": "Municipal elections were held this year.",
          "droughtDeaths": "deaths estimated due to droughts"
        },
        "presidentialElections": {
          "title": "Presidential Elections",
          "description": "Presidential elections were held this year.",
          "heatwaves": "heatwaves observed"
        },
        "warming": {
          "title": "Exceeding 1.4°C",
          "description": "The 1.4°C exceeded globally.",
          "dryDays": "days without rain"
        },
        "unknown": {
          "title": "Unknown Event",
          "description": "No specific event for this year.",
          "dryDays": "days without rain"
        }
      },
      "actors-round-votes": "Here are the votes available to each actor for this round:",
      "popularity-crisis-1": "Water restrictions have sparked growing discontent among citizens. Dry gardens, limited washing: frustration is mounting over the constraints imposed to preserve this vital resource. Protests have erupted, with the population demanding that everyone contributes to the collective effort and that measures do not target them alone. Awareness and collaborative solutions will be essential to find a sustainable balance.",
      "popularity-crisis-2": "In response to these demands, the prefect decides to redistribute one vote from each of the three most powerful actors to the consumers.",
      "biodiversity-crisis-1": "Previous measures to counter the biodiversity crisis have had detrimental effects on fragile ecosystems. Activists are criticizing the leaders for their flagrant laxity in the face of species loss, habitat destruction, and environmental degradation. Citizens are demanding concrete actions and collective responsibility to preserve our precious natural heritage. Awareness and bold political decisions will be essential to protect our planet.",
      "biodiversity-crisis-2": "In response to these demands, the prefect decides to redistribute one vote from each of the three most powerful actors to the OFB.",
      "carbon-crisis-1": "A major energy crisis is currently affecting the region, which is experiencing an unprecedented drought. Water levels are at record lows, and several nuclear power plants have had to slow down or even cease operations due to the risk of not being able to ensure their cooling. Emergency measures have been taken to encourage a reduction in energy consumption. A coal-fired power plant will be restarted to meet the demand.",
      "carbon-crisis-2": "In response to this situation, the prefect decides to redistribute one vote from each of the three most powerful actors to the energy sector.",
      "economy-crisis-1": "The current economic crisis has hit the region hard following measures taken as part of the water plan, impacting tourism and some major local industries. This endangers jobs, incomes, and the region's attractiveness, with massive layoffs and business closures. A concerted approach and innovative solutions will be necessary to overcome these major economic challenges and restore regional vitality.",
      "economy-crisis-2": "In response to this situation, the prefect decides to redistribute one vote from each of the three most powerful actors to the industrial sector.",
      "quality-crisis-1": "A water quality crisis is affecting the region following revelations from independent media such as Brut and Mediapart about non-compliance with established standards. Concerns are growing among residents, jeopardizing public health. Decisive actions are needed to restore water quality and regain citizens' trust in their potable water supply.",
      "quality-crisis-2": "In response to this situation, the prefect decides to redistribute one vote from each of the three most powerful actors to the DREAL.",
      "game-summary-title": "End of Game Report",
      "game-summary-actors-highlighted": "The actors who stood out:",
      "game-summary-most-effort": "Actor who made the most effort:",
      "game-summary-team-results": "Your team's results:",
      "game-summary-decisions-taken": "decisions made during the game",
      "game-summary-better-than-other-games": "of other games are worse",
      "game-summary-return-home": "Return to Home",
      "workshops-animated": "Workshops delivered",
      "people-trained": "People trained",
      "pending-workshop": "Pending workshop",
      "hello": "Hello",
      "my-stats": "My statistics",
      "my-workshops": "My workshops",
      "access": "Access",
      "started": "Started",
      "players": "players",
      "created-at": "Created on",
      "create-new-workshop": "Create a new workshop",
      "facilitator-resources": "Facilitator resources",
      "game-configuration": "Game configuration",
      "workshop-name": "Name of your workshop",
      "number-of-actors": "Number of actors",
      "including-client": "Including the client",
      "workshop-configuration": "Workshop configuration",
      "audience-type": "Type of audience",
      "real-number-participants": "Actual number of participants",
      "show-scores": "Show scores",
      "additional-happening": "Additional event",
      "create-and-play-now": "Create the game and play now",
      "selected-actors": "You have selected {{numberPlayer}} actors.",
      "finished": "Finished",
      "pending": "Pending",
      "general-public": "General public",
      "company": "Company",
      "association": "Association",
      "private-circle": "Private circle",
      "community": "Community",
      "higher-education": "Higher education",
      "test": "Test",
      "login": "Log in",
      "email": "email",
      "password": "password",
      "demo-workshop": "Demo workshop",
      "enter-a-number": "Enter a number",
      "all": "All",

      "yes": "Yes",
      "no": "No",
      "actors": "Protagonists",
      "compte-gouttes-name": "Aqua Shift Workshop",
      "tuto-video-link":"https://res.cloudinary.com/dc1felxem/video/upload/v1757690726/Role_play_Explanation_-_Atelier_Compte_Gouttes_tmk7oi.mp4",
      "map_meteo_crisis": "https://res.cloudinary.com/dc1felxem/image/upload/v1686062229/meteo_qcrnpx.png",
      "bonne-voie": "on the right track",
      "danger": "danger",
      "tres-intenses": "very intense",
      "intenses": "intense",
      "maitrisees": "controlled",
      "court-terme": "short term",
      "long-terme": "long term",

    
    },
  },



  fr: {
    translation: {
      "welcome": "Bienvenue dans l'Atelier Compte-Gouttes",
      "validate_decision": "Valider la décision",
      "Suivant": "Suivant",
      "Précédent" : "Précédent",
      "Déroulement de l'atelier": "Déroulement de l'atelier",
      "Commencer le jeu": "Commencer le jeu",
      "Commencer l'atelier": "Commencer l'atelier",
      "Voici les voix dont disposent chaque acteur pour ce tour": "Voici les voix dont disposent chaque acteur pour ce tour",
      "Tour": "Tour",
      "Situation de crise - choisissez des mesures d'urgence": "Situation de crise - choisissez des mesures d'urgence",
      "Valider la décision" : "Valider la décision",
      "Tours": "Tours",
      "Économie d'eau": "Économie d'eau",
      "Agriculture": "Agriculture",
      "Industrie": "Industrie",
      "Public": "Public",
      "Consommateurs": "Consommateurs",
      "Courbe d'objectif": "Courbe d'objectif",    
      "endOfLastRound": "C'est la fin de votre dernier tour !",
      "congratulations": "Félicitations !",
      "achievement": "Vous avez atteint {{percentage}}% de votre objectif.",
      "waterSavingsRecap": "Voici le récapitulatif des économies d'eau que vous avez réalisées au cours du temps :",
      "welcomeMessage": "Bonjour à toutes et tous, nous sommes en {{year}}, bienvenue au {{congressNumber}}ème Congrès sur l'eau.",
      "objectivesStatus": "Les objectifs à horizon 10 ans sont en {{objectives}}, cette année on prévoit des sécheresses {{droughtType}}, il faudra axer nos décisions sur des mesures {{measuresTerm}}.",
      "lowPrecipitation": "Cette année les niveaux de précipitation ont été particulièrement faibles, certains cours d'eau sont bientôt à sec et les nappes phréatiques sont sous grande tension. Nous faisons face à une sécheresse.",
      "shortTermNeeds": "Vous devez économiser {{needs}}",
      "waterDrop": "goutte d'eau",
      "nextTurn": " lors du prochain tour.",
      "waterSavingsEvolution": "Évolution des économies d'eau",
      "otherIndicators": "Autres Indicateurs",
      "impactOtherIndicators": "Impact sur les autres indicateurs",
      "discoverTerritory": "Découvrez à quoi ressemble votre territoire !",
      "downloadPDF": "Télécharger le PDF",
      "gameSummary": "Bilan de partie",
      "accessSummary": "Accéder au bilan de partie",
      "reviewPastEvents": "Revenons sur les événements marquants de l'an passé",
      "biodiversity": "Biodiversité",
      "energySobriety": "Sobriété énergétique",
      "economicHealth": "Santé économique",
      "popularity": "Popularité",
      "waterQuality": "Qualité de l'eau",
      "context": {
        "title": "Contexte",
        "householdsWithoutWater": "personnes ont été privées d'eau",
        "awarenessCampaign": "personnes sensibilisées à l'eau"
      },
      "events": {
        "olympics": {
          "title": "Jeux Olympiques",
          "description": "Les Jeux Olympiques ont eu lieu cette année.",
          "heatwaves": "canicules observées"
        },
        "cop30": {
          "title": "COP 30 au Brésil",
          "description": "COP 30 au Brésil",
          "hottestYear": "année la plus chaude enregistrée"
        },
        "localElections": {
          "title": "Élections Municipales",
          "description": "Les élections municipales ont eu lieu cette année.",
          "droughtDeaths": "décès estimés à cause des sécheresses"
        },
        "presidentialElections": {
          "title": "Élections Présidentielles",
          "description": "Les élections présidentielles ont eu lieu cette année.",
          "heatwaves": "canicules observées"
        },
        "warming": {
          "title": "Dépassement des 1,4°C",
          "description": "Le seuil de 1,4° dépassé.",
          "dryDays": "jours sans pluie"
        },
        "unknown": {
          "title": "Événement inconnu",
          "description": "Aucun événement spécifique pour cette année.",
          "dryDays": "jours sans pluie"
        }
      },
      "actors-round-votes": "Voici les voix dont disposent chaque acteur pour ce tour :",
      "popularity-crisis-1": "Les restrictions d'eau ont suscité un mécontentement croissant parmi les citoyens. Jardins asséchés, lavages limités : la frustration grandit face aux contraintes imposées pour préserver cette ressource vitale. Des manifestations ont éclaté, la population demandant que tous participent à l'effort collectif et que les mesures ne les ciblent pas seuls. Sensibilisation et solutions collaboratives seront essentielles pour trouver un équilibre durable.",
      "popularity-crisis-2": "Face à ces revendications, le préfet décide de redistribuer une voix de chacun des trois acteurs les plus puissants aux consommateurs.",
      "biodiversity-crisis-1": "Les mesures précédentes pour contrer la crise de biodiversité ont eu des conséquences néfastes sur les écosystèmes fragiles. Des activistes reprochent un laxisme flagrant des dirigeants, face à la perte de diversité des espèces, la destruction des habitats et la dégradation de l'environnement. Les citoyens exigent des actions concrètes et une prise de responsabilité collective pour préserver notre précieux héritage naturel. Sensibilisation et décisions politiques audacieuses seront essentielles pour protéger notre planète.",
      "biodiversity-crisis-2": "Face à ces revendications, le préfet décide de redistribuer une voix de chacun des trois acteurs les plus puissants à l’OFB.",
      "carbon-crisis-1": "Une crise énergétique de grande ampleur frappe actuellement la région, qui fait face à une sécheresse sans précédent. Les cours d’eau sont au plus bas et plusieurs centrales nucléaires ont dû ralentir voire même stopper leur activité à cause du risque de ne pas pouvoir assurer leur refroidissement. Des mesures ont été prises en urgence pour inciter à la diminution de la consommation énergétique. Une centrale à charbon va être relancée pour pallier à la demande.",
      "carbon-crisis-2": "Face à cette situation, le préfet décide de redistribuer une voix de chacun des trois acteurs les plus puissants au secteur de l’énergie.",
      "economy-crisis-1": "La crise économique actuelle a durement frappé la région suite aux mesures prises dans le cadre du plan eau, impactant le tourisme et certaines grandes industries locales. Cela met en péril l'emploi, les revenus et l'attractivité de la région, avec des licenciements massifs et des fermetures d'entreprises. Une approche concertée et des solutions innovantes seront nécessaires pour surmonter ces défis économiques majeurs et restaurer la vitalité régionale.",
      "economy-crisis-2": "Face à cette situation, le préfet décide de redistribuer une voix de chacun des trois acteurs les plus puissants au secteur industriel.",
      "quality-crisis-1": "Une crise de qualité de l'eau frappe la région, suite aux révélations de médias indépendants tels que Brut ou Mediapart sur des non-conformités aux normes établies. Les inquiétudes grandissent parmi les résidents, mettant en jeu la santé publique. Des actions décisives sont nécessaires pour rétablir la qualité de l'eau et regagner la confiance des citoyens dans leur approvisionnement en eau potable.",
      "quality-crisis-2": "Face à cette situation, le préfet décide de redistribuer une voix de chacun des trois acteurs les plus puissants à la DREAL.",
      "game-summary-title": "Rapport de fin de partie",
      "game-summary-actors-highlighted": "Les acteurs qui se sont démarqués :",
      "game-summary-most-effort": "Acteur qui a fait le plus d'effort :",
      "game-summary-team-results": "Vos résultats d'équipe :",
      "game-summary-decisions-taken": "décisions prises au cours de la partie",
      "game-summary-better-than-other-games": "des autres parties sont moins bonnes",
      "game-summary-return-home": "Retour à l'accueil",
      "workshops-animated": "Ateliers animés",
      "people-trained": "Personnes formées",
      "pending-workshop": "Atelier en attente",
      "hello": "Bonjour",
      "my-stats": "Mes statistiques",
      "my-workshops": "Mes ateliers",
      "access": "Accéder",
      "started": "Commencé",
      "players": "joueurs",
      "created-at": "Créé le",
      "create-new-workshop": "Créer un nouvel atelier",
      "facilitator-resources": "Ressources animateur",
      "game-configuration": "Configuration du jeu",
      "workshop-name": "Nom de votre atelier",
      "number-of-actors": "Nombre d'acteurs",
      "including-client": "Dont le client",
      "workshop-configuration": "Configuration Atelier",
      "audience-type": "Type de public",
      "real-number-participants": "Nombre réel de participants",
      "show-scores": "Afficher les scores",
      "additional-happening": "Happening supplémentaire",
      "create-and-play-now": "Créer le jeu et jouer maintenant",
      "selected-actors": "Vous avez sélectionné {{numberPlayer}} acteurs.",
      "finished": "Fini",
      "pending": "En attente",
      "general-public": "Grand public",
      "company": "Entreprise",
      "association": "Association",
      "private-circle": "Cercle privé",
      "community": "Collectivité",
      "higher-education": "Enseignement supérieur",
      "test": "Test",
      "login": "Connectez-vous",
      "email": "email",
      "password": "mot de passe",
      "demo-workshop": "Atelier de démonstration",
      "enter-a-number": "Entrez un nombre",
      "all": "Tous",
      "compte-gouttes-name": "L'Atelier Compte-Gouttes",
      "yes": "Oui",
      "no": "Non",
      "actors": "Acteurs",
      "tuto-video-link":"https://res.cloudinary.com/dc1felxem/video/upload/v1757689476/Comment_jouer_a%CC%80_lAtelier_Compte-Gouttes_1_cbutet.mp4",
      "map_meteo_crisis": "https://res.cloudinary.com/dc1felxem/image/upload/v1686062229/meteo_qcrnpx.png",
      "bonne-voie": "bonne voie",
      "danger": "danger",
      "tres-intenses": "très intenses",
      "intenses": "intenses",
      "maitrisees": "maîtrisées",
      "court-terme": "court terme",
      "long-terme": "long terme",




    }   
  },


  es: {
    translation: {
      "welcome": "Bienvenidos al Taller Cuenta-Gotas",
      "validate_decision": "Validar la decisión",
      "Suivant": "Siguiente",
      "Précédent": "Anterior",
      "Déroulement de l'atelier": "Desarrollo del taller",
      "Commencer le jeu": "Comenzar el juego",
      "Commencer l'atelier": "Comenzar el taller",
      "Voici les voix dont disposent chaque acteur pour ce tour": "Aquí están los votos de cada actor para este turno",
      "Tour": "Turno",
      "Situation de crise — choisissez des mesures d'urgence": "Situación de crisis - elija medidas de emergencia",
      "Valider la décision": "Validar la decisión",
      "Tours": "Turnos",
      "Économie d'eau": "Ahorro de agua",
      "Agriculture": "Agricultura",
      "Industrie": "Industria",
      "Public": "Público",
      "Consommateurs": "Consumidores",
      "Courbe d'objectif": "Curva del objetivo",    
      "endOfLastRound": "¡Es el final de tu último turno!",
      "congratulations": "¡Felicidades!",
      "achievement": "Has alcanzado el {{percentage}}% de tu objetivo.",
      "waterSavingsRecap": "Aquí está el resumen de los ahorros de agua que has logrado a lo largo del tiempo:",
      "welcomeMessage": "Hola a todas y todos, estamos en el año {{year}}, bienvenidos al {{congressNumber}}º Congreso del Agua.",
      "objectivesStatus": "Los objetivos a 10 años están en {{objectives}}, este año se prevén sequías {{droughtType}}, habrá que enfocar nuestras decisiones en medidas {{measuresTerm}}.",
      "lowPrecipitation": "Este año los niveles de precipitación han sido particularmente bajos, algunos ríos están a punto de secarse y los acuíferos están bajo gran tensión. Nos enfrentamos a una sequía.",
      "shortTermNeeds": "Debes ahorrar {{needs}}",
      "waterDrop": "gota de agua",
      "nextTurn": " en el próximo turno.",
      "waterSavingsEvolution": "Evolución de los ahorros de agua",
      "otherIndicators": "Otros indicadores",
      "impactOtherIndicators": "Impacto en otros indicadores",
      "discoverTerritory": "¡Descubre cómo es tu territorio!",
      "downloadPDF": "Descargar el PDF",
      "gameSummary": "Resumen de la partida",
      "accessSummary": "Acceder al resumen de la partida",
      "reviewPastEvents": "Revisemos los acontecimientos destacados del año pasado",
      "biodiversity": "Biodiversidad",
      "energySobriety": "Sobriedad energética",
      "economicHealth": "Salud económica",
      "popularity": "Popularidad",
      "waterQuality": "Calidad del agua",
      "context": {
        "title": "Contexto",
        "householdsWithoutWater": "personas se quedaron sin agua",
        "awarenessCampaign": "personas sensibilizadas sobre el agua"
      },
      "events": {
        "olympics": {
          "title": "Juegos Olímpicos",
          "description": "Los Juegos Olímpicos tuvieron lugar este año.",
          "heatwaves": "olas de calor observadas"
        },
        "cop30": {
          "title": "COP 30 en Brasil",
          "description": "COP 30 en Brasil",
          "hottestYear": "año más caluroso registrado"
        },
        "localElections": {
          "title": "Elecciones Municipales",
          "description": "Las elecciones municipales tuvieron lugar este año.",
          "droughtDeaths": "muertes estimadas debido a las sequías"
        },
        "presidentialElections": {
          "title": "Elecciones Presidenciales",
          "description": "Las elecciones presidenciales tuvieron lugar este año.",
          "heatwaves": "olas de calor observadas"
        },
        "warming": {
          "title": "Superación de 1,4°C",
          "description": "Se ha superado el umbral de 1,4°C.",
          "dryDays": "días sin lluvia"
        },
        "unknown": {
          "title": "Evento desconocido",
          "description": "Ningún evento específico para este año.",
          "dryDays": "días sin lluvia"
        }
      },
      "actors-round-votes": "Aquí están los votos de cada actor para este turno:",
      "popularity-crisis-1": "Las restricciones de agua han generado un creciente descontento entre los ciudadanos. Jardines secos, lavados limitados: la frustración aumenta frente a las restricciones impuestas para preservar este recurso vital. Han estallado manifestaciones, la población exige que todos participen en el esfuerzo colectivo y que las medidas no se centren únicamente en ellos. La sensibilización y las soluciones colaborativas serán esenciales para encontrar un equilibrio sostenible.",
      "popularity-crisis-2": "Ante estas demandas, el prefecto decide redistribuir un voto de cada uno de los tres actores más poderosos a los consumidores.",
      "biodiversity-crisis-1": "Las medidas anteriores para contrarrestar la crisis de biodiversidad han tenido consecuencias negativas en los ecosistemas frágiles. Activistas acusan a los dirigentes de un claro laissez-faire frente a la pérdida de diversidad de especies, la destrucción de hábitats y la degradación ambiental. Los ciudadanos exigen acciones concretas y una responsabilidad colectiva para preservar nuestro valioso patrimonio natural. La sensibilización y decisiones políticas audaces serán esenciales para proteger nuestro planeta.",
      "biodiversity-crisis-2": "Ante estas demandas, el prefecto decide redistribuir un voto de cada uno de los tres actores más poderosos al OFB.",
      "carbon-crisis-1": "Una gran crisis energética golpea actualmente a la región, que enfrenta una sequía sin precedentes. Los ríos están en mínimos históricos y varias centrales nucleares han tenido que reducir o incluso detener su actividad por el riesgo de no poder garantizar su refrigeración. Se han tomado medidas de emergencia para reducir el consumo energético. Una central de carbón será reactivada para responder a la demanda.",
      "carbon-crisis-2": "Ante esta situación, el prefecto decide redistribuir un voto de cada uno de los tres actores más poderosos al sector energético.",
      "economy-crisis-1": "La actual crisis económica ha golpeado duramente a la región debido a las medidas adoptadas en el marco del plan del agua, afectando al turismo y a varias grandes industrias locales. Esto pone en riesgo el empleo, los ingresos y la competitividad regional, con despidos masivos y cierres de empresas. Será necesario un enfoque concertado y soluciones innovadoras para superar estos grandes retos económicos y restaurar la vitalidad regional.",
      "economy-crisis-2": "Ante esta situación, el prefecto decide redistribuir un voto de cada uno de los tres actores más poderosos al sector industrial.",
      "quality-crisis-1": "Una crisis de calidad del agua golpea a la región, tras las revelaciones de medios independientes como Brut o Mediapart sobre incumplimientos de las normas establecidas. Crecen las preocupaciones entre los residentes, poniendo en riesgo la salud pública. Se necesitan acciones decisivas para restablecer la calidad del agua y recuperar la confianza de los ciudadanos en su suministro de agua potable.",
      "quality-crisis-2": "Ante esta situación, el prefecto decide redistribuir un voto de cada uno de los tres actores más poderosos a la DREAL.",
      "game-summary-title": "Informe de fin de partida",
      "game-summary-actors-highlighted": "Los actores que más se destacaron:",
      "game-summary-most-effort": "Actor que más esfuerzo hizo:",
      "game-summary-team-results": "Resultados de tu equipo:",
      "game-summary-decisions-taken": "decisiones tomadas durante la partida",
      "game-summary-better-than-other-games": "de las otras partidas son peores",
      "game-summary-return-home": "Volver al inicio",
      "workshops-animated": "Talleres realizados",
      "people-trained": "Personas formadas",
      "pending-workshop": "Taller pendiente",
      "hello": "Hola",
      "my-stats": "Mis estadísticas",
      "my-workshops": "Mis talleres",
      "access": "Acceder",
      "started": "Iniciado",
      "players": "jugadores",
      "created-at": "Creado el",
      "create-new-workshop": "Crear un nuevo taller",
      "facilitator-resources": "Recursos del facilitador",
      "game-configuration": "Configuración del juego",
      "workshop-name": "Nombre de tu taller",
      "number-of-actors": "Número de actores",
      "including-client": "Incluyendo al cliente",
      "workshop-configuration": "Configuración del taller",
      "audience-type": "Tipo de público",
      "real-number-participants": "Número real de participantes",
      "show-scores": "Mostrar los puntajes",
      "additional-happening": "Evento adicional",
      "create-and-play-now": "Crear el juego y jugar ahora",
      "selected-actors": "Has seleccionado {{numberPlayer}} actores.",
      "finished": "Terminado",
      "pending": "En espera",
      "general-public": "Público general",
      "company": "Empresa",
      "association": "Asociación",
      "private-circle": "Círculo privado",
      "community": "Colectividad",
      "higher-education": "Educación superior",
      "test": "Prueba",
      "login": "Conéctate",
      "email": "correo electrónico",
      "password": "contraseña",
      "demo-workshop": "Taller de demostración",
      "enter-a-number": "Introduce un número",
      "all": "Todos",
      "compte-gouttes-name": "Taller Cuentagotas",
      "yes": "Sí",
      "no": "No",
      "actors": "Actores",
      "tuto-video-link":"https://res.cloudinary.com/dc1felxem/video/upload/v1761840509/Design_sans_titre_1_1_ew5isd.mp4",
      "map_meteo_crisis": "https://res.cloudinary.com/dc1felxem/image/upload/v1761063533/WhatsApp_Image_2025-10-21_at_15.30.35_loa7pw.jpg",
      "bonne-voie": "buen camino",
      "danger": "peligro",
      "tres-intenses": "muy intensas",
      "intenses": "intensas",
      "maitrisees": "controladas",
      "court-terme": "corto plazo",
      "long-terme": "largo plazo",




    }   
  },
};

i18n
  .use(initReactI18next) // Passes i18n instance to react-i18next.
  .init({
    resources,
    lng: "fr", // Default language
    fallbackLng: "fr", // Fallback language if the selected one is not available
    interpolation: {
      escapeValue: false, // React already escapes strings
    },
  });

export default i18n;
